import NewReleaseSustain from './new-release-sustain';

export * from './new-release-sustain';
export default NewReleaseSustain;
